import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import CustomerTransactionApi from '../generated/api/CustomerTransaction';

export default (service: Servicelayer) => ({
  ...CustomerTransactionApi(service),

  // Add custom calls here

});
